export default {
    state: () => ({
        data: { }
    }),
    mutations: {
        ['service/setState'](state, payload) {
            state.data = {...payload,}
        },
    },
    actions: {
    },
}
